module.exports = __webpack_public_path__ + "static/media/gridia-accent.5d9c60df.svg";